import type { EngineConfig, EngineStepResult, Letter } from './types';

export function integrateLetters(
  letters: readonly Letter[],
  dt: number,
  config: EngineConfig
): EngineStepResult {
  if (dt <= 0) {
    return {
      letters: letters.map((letter) => ({ ...letter })),
      missed: [],
    };
  }

  const updated: Letter[] = [];
  const missed: Letter[] = [];

  for (const letter of letters) {
    if (!letter.alive) {
      updated.push({ ...letter, alive: false });
      continue;
    }

    const vy = Math.min(letter.vy + config.gravity * dt, config.terminalVelocity);
    const y = letter.y + vy * dt;
    const alive = y < config.floorY;
    const next: Letter = { ...letter, vy, y, alive };
    updated.push(next);
    if (!alive) {
      missed.push(next);
    }
  }

  return {
    letters: updated,
    missed,
  };
}
